import React from 'react'
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgAutoplay from "lightgallery/plugins/autoplay";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgRotate from "lightgallery/plugins/rotate";
const CRMCustomer = () => {
  return (
    <>
      <section id="second" className="powerpoint-sec facts bg2 second">
        <div className="container">
          <div className="section-title mt-4">
            <h2 className="animated fadeInDown pt-4">Customer</h2>
            <div className="bar" />
            <div className="mt-4">
              <div className="row">
                <div className="col-lg-12">
                  <ul
                    className="nav nav-tabs app-nav focus tabs-width"
                    id="myTab-partner"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      {" "}
                      <a
                        className="nav-link active android"
                        id="android-tab"
                        data-toggle="tab"
                        href="#android-customer"
                        role="tab"
                        aria-controls="cust-android"
                        aria-selected="false"
                      >
                        <span>
                          <i className="bx bxl-android" />
                        </span>
                        Android App
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      {" "}
                      <a
                        className="nav-link"
                        id="ios-tab"
                        data-toggle="tab"
                        href="#ios-customer"
                        role="tab"
                        aria-controls="cust-ios"
                        aria-selected="false"
                      >
                        <span>
                          <i className="bx bxl-apple" />
                        </span>
                        iOS App
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="nav-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="android-customer"
                      role="tabpanel"
                      aria-labelledby="android-tab"
                    >
                      <div className="row shadow m-2">
                        <div className="col-md-12 p-0">
                          <div>
                            <ul
                              className="nav nav-tabs mesee focus bg-dark-bg feature-tabs-width"
                              id="myTab"
                              role="tablist"
                            >
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link active btn text-white"
                                  id="home-tab-ca"
                                  data-toggle="tab"
                                  href="#home-ca"
                                  role="tab"
                                  aria-controls="home"
                                  aria-selected="true"
                                >
                                  About
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="profile-tab-ca"
                                  data-toggle="tab"
                                  href="#profile-ca"
                                  role="tab"
                                  aria-controls="profile"
                                  aria-selected="false"
                                >
                                  Features
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="audio-tab-ca"
                                  data-toggle="tab"
                                  href="#audio-ca"
                                  role="tab"
                                  aria-controls="audio"
                                  aria-selected="false"
                                >
                                  Gallery
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade show active"
                                id="home-ca"
                                role="tabpanel"
                                aria-labelledby="home-tab-ca"
                              >
                                {/* <div class="Description mt-5">
                            <h6 class="text-left">Gallery</h6>
                          </div> */}
                                <div className="shadow-none p-3 mb-5  bg-white rounded">
                                  <div className="row">
                                    <div className="col-lg-7">
                                      <div className="mt-5">
                                        <img
                                          src="assets/img/CRM/image-1.webp"
                                          className="animated fadeInLeft img-fluid" alt="Project Screens"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-5">
                                      <h3 className="mt-3 animated fadeInUp ease-out-circ d2 a-1 f2 fw3">
                                        CRM-Fixfella
                                      </h3>
                                      <p className="animated bounceIn ease-in-quad d-2 mt4 text-justify p-2">
                                        Customer will generate the complaint with the
                                        help of mobile application or via call (IVR
                                        calling system - Need to implement via API.
                                        API will be provided by client). Once the
                                        complaint is raised then it will go to NSC.
                                        Now NSC will assign the registered call to the
                                        Dealer.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="profile-ca"
                                role="tabpanel"
                                aria-labelledby="profile-tab-ca"
                              >
                                {/* <div class="Description mt-5">
                        <h6 class="text-left">Feature</h6>
                      </div> */}
                                <div className="shadow-none py-5 mb-5 bg-light rounded">
                                  <div className="row ">
                                    <div className="col-lg-4 mb-2">
                                      <div
                                        className="list-group"
                                        id="list-tab"
                                        role="tablist"
                                      >
                                        {" "}
                                        <a
                                          className="list-group-item list-group-item-action active"
                                          id="list-home-list"
                                          data-toggle="list"
                                          href="#list-home"
                                          role="tab"
                                          aria-controls="home"
                                        >
                                          Create Account
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-profile-list"
                                          data-toggle="list"
                                          href="#list-profile"
                                          role="tab"
                                          aria-controls="profile"
                                        >
                                          Select Service
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-messages-list"
                                          data-toggle="list"
                                          href="#list-messages"
                                          role="tab"
                                          aria-controls="messages"
                                        >
                                          Track Your Order
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-settings-list"
                                          data-toggle="list"
                                          href="#list-settings"
                                          role="tab"
                                          aria-controls="settings"
                                        >
                                          Rate Your Partner
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-next-list"
                                          data-toggle="list"
                                          href="#list-next"
                                          role="tab"
                                          aria-controls="next"
                                        >
                                          Help Center
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-tonext-list"
                                          data-toggle="list"
                                          href="#list-tonext"
                                          role="tab"
                                          aria-controls="tonext"
                                        >
                                          Profile Details
                                        </a>
                                      </div>
                                    </div>
                                    <div className="col-lg-8">
                                      <div className="border shadow-none p-3">
                                        <div
                                          className="tab-content"
                                          id="nav-tabContent"
                                        >
                                          <div
                                            className="tab-pane fade show active"
                                            id="list-home"
                                            role="tabpanel"
                                            aria-labelledby="list-home-list"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="#">Create Account</h5>
                                              <li>
                                                You can Create an Account Use your
                                                Mobile / Email.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-profile"
                                            role="tabpanel"
                                            aria-labelledby="list-profile-list"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="">Select Service</h5>
                                              <li>Select Services</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-messages"
                                            role="tabpanel"
                                            aria-labelledby="list-messages-list"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="#">Track Your Order</h5>
                                              <li>Track Your Job Order</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-settings"
                                            role="tabpanel"
                                            aria-labelledby="list-settings-list list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Rate Your Partner</h5>
                                              <li>
                                                After Services Rate your Partner.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-next"
                                            role="tabpanel"
                                            aria-labelledby="list-next-list list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Help Center</h5>
                                              <li>
                                                Take Support from your Help Center.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-tonext"
                                            role="tabpanel"
                                            aria-labelledby="list-tonext-list list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Profile Details</h5>
                                              <li>See Your profile Details.</li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="audio-ca"
                                role="tabpanel"
                                aria-labelledby="audio-tab-pa"
                              >
                                {/*  <div class="Description mt-5">
                        <h6 class="text-left">Gallery</h6>
                      </div> */}
                                <div className="shadow-none p-3 mb-5 bg-light rounded">
                                  <section className="container">
                                    <div className="row gallery py-5">
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-Customer.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-Customer.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-Customer-2.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-Customer-2.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-Customer-3.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-Customer-3.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-Customer-4.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-Customer-4.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="ios-customer"
                      role="tabpanel"
                      aria-labelledby="ios-tab"
                    >
                      <div className="row shadow m-2">
                        <div className="col-md-12 p-0">
                          <div>
                            <ul
                              className="nav nav-tabs mesee focus bg-dark-bg feature-tabs-width"
                              id="myTab"
                              role="tablist"
                            >
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link active btn text-white"
                                  id="home-tab-ci"
                                  data-toggle="tab"
                                  href="#home-ci"
                                  role="tab"
                                  aria-controls="home"
                                  aria-selected="true"
                                >
                                  About
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="profile-tab-ci"
                                  data-toggle="tab"
                                  href="#profile-ci"
                                  role="tab"
                                  aria-controls="profile"
                                  aria-selected="false"
                                >
                                  Features
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="audio-tab-ci"
                                  data-toggle="tab"
                                  href="#audio-ci"
                                  role="tab"
                                  aria-controls="audio"
                                  aria-selected="false"
                                >
                                  Gallery
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade show active"
                                id="home-ci"
                                role="tabpanel"
                                aria-labelledby="home-tab-pi"
                              >
                                {/* <div class="Description mt-5">
                            <h6 class="text-left">Gallery</h6>
                          </div> */}
                                <div className="shadow-none p-3 mb-5  bg-white rounded">
                                  <div className="row">
                                    <div className="col-lg-7">
                                      <div className="mt-5">
                                        <img
                                          src="assets/img/CRM/image-2.webp"
                                          className="animated fadeInLeft img-fluid" alt="Project Screens"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-5">
                                      <h3 className="mt-3 animated fadeInUp ease-out-circ d2 a-1 f2 fw3">
                                        CRM-Fixfella
                                      </h3>
                                      <p className="animated bounceIn ease-in-quad d-2 mt4 text-justify p-2">
                                        Customers will generate the complaint with the
                                        help of mobile application or via call (IVR
                                        calling system - Need to implement via API.
                                        API will be provided by client). Once the
                                        complaint is raised then it will go to NSC.
                                        Now NSC will assign the registered call to the
                                        Dealer.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="profile-ci"
                                role="tabpanel"
                                aria-labelledby="profile-tab-ci"
                              >
                                {/* <div class="Description mt-5">
                        <h6 class="text-left">Feature</h6>
                      </div> */}
                                <div className="shadow-none py-5 mb-5 bg-light rounded">
                                  <div className="row">
                                    <div className="col-lg-4 mb-2">
                                      <div>
                                        <div
                                          className="list-group"
                                          id="list-tab"
                                          role="tablist"
                                        >
                                          {" "}
                                          <a
                                            className="list-group-item list-group-item-action active"
                                            id="list-home-list-f07"
                                            data-toggle="list"
                                            href="#list-home-f07"
                                            role="tab"
                                            aria-controls="home-f07"
                                          >
                                            Create Account
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-profile-list-f08"
                                            data-toggle="list"
                                            href="#list-profile-f08"
                                            role="tab"
                                            aria-controls="profile-f08"
                                          >
                                            Select Service
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-messages-list-f09"
                                            data-toggle="list"
                                            href="#list-messages-f09"
                                            role="tab"
                                            aria-controls="messages-f09"
                                          >
                                            Track Your Order
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-settings-list-f10"
                                            data-toggle="list"
                                            href="#list-settings-f10"
                                            role="tab"
                                            aria-controls="settings-f10"
                                          >
                                            Rate Your Partner
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-next-list-f11"
                                            data-toggle="list"
                                            href="#list-next-f11"
                                            role="tab"
                                            aria-controls="next-f11"
                                          >
                                            Help Center
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-tonext-list-f12"
                                            data-toggle="list"
                                            href="#list-tonext-f12"
                                            role="tab"
                                            aria-controls="tonext-f12"
                                          >
                                            Profile Details
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-8">
                                      <div className="border shadow-none p-3">
                                        <div
                                          className="tab-content"
                                          id="nav-tabContent"
                                        >
                                          <div
                                            className="tab-pane fade show active"
                                            id="list-home-f07"
                                            role="tabpanel"
                                            aria-labelledby="list-home-list-f07"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="#">Create Account</h5>
                                              <li>
                                                You can Create an Account Use your
                                                Mobile / Email.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-profile-f08"
                                            role="tabpanel"
                                            aria-labelledby="list-profile-list-f08"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Select Service</h5>
                                              <li>Select Services</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-messages-f09"
                                            role="tabpanel"
                                            aria-labelledby="list-messages-list-f09"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Track Your Order</h5>
                                              <li>Track Your Job Order</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-settings-f10"
                                            role="tabpanel"
                                            aria-labelledby="list-settings-list-f10 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Rate Your Partner</h5>
                                              <li>
                                                After Services Rate your Partner.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-next-f11"
                                            role="tabpanel"
                                            aria-labelledby="list-next-list-f11 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Help Center</h5>
                                              <li>
                                                Take Support from your Help Center.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-tonext-f12"
                                            role="tabpanel"
                                            aria-labelledby="list-tonext-list-f12 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Profile Details</h5>
                                              <li>See Your profile Details.</li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="audio-ci"
                                role="tabpanel"
                                aria-labelledby="audio-tab-ci"
                              >
                                <div className="shadow-none p-3 mb-5 bg-light rounded">
                                  <section className="container">
                                    <div className="row gallery py-5">
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Customer-iOS.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Customer-iOS.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Customer-iOS-2.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Customer-iOS-2.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Customer-iOS-3.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Customer-iOS-3.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Customer-iOS-4.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Customer-iOS-4.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default CRMCustomer